import styled from "styled-components";

export const Credit = styled.div`
text-align: center;
margin: 150px 0 50px 0;
`